import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1156">
      <About data-id="element-1157" />
    </main>;
}